import React from "react"
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap"

function FeedbackModal({
  feedbackModal,
  toggleFeedbackModal,
  conversationActions,
}) {
  const handleConfirmFeedback = () => {
    conversationActions("feedback") // Call the feedback action
    toggleFeedbackModal() // Close the modal
  }

  return (
    <Modal isOpen={feedbackModal} toggle={toggleFeedbackModal} centered>
      <ModalHeader toggle={toggleFeedbackModal}>Send Feedback</ModalHeader>
      <ModalBody>Verify that you want to send feedback.</ModalBody>
      <ModalFooter style={{ borderTop: "0", paddingTop: "0" }}>
        <Button
          color="secondary"
          outline
          onClick={toggleFeedbackModal}
          style={{ padding: "0.1875rem 0.875rem" }}
        >
          Cancel
        </Button>
        <Button
          color="secondary"
          onClick={handleConfirmFeedback}
          style={{ padding: "0.1875rem 0.875rem" }}
        >
          Confirm
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default FeedbackModal
